import { useState, useEffect, useRef } from "react";

// This is a custom store implementation similar to Redux/Zustand pattern
// Creates a store with subscription management and React hook integration

function createStore(setup, externalSubscribers) {
   let store;
   const subscribers = externalSubscribers || new Set();

   const set = (update) => {
     if (typeof update === "function") {
       store = { ...store, ...update(store) };
     } else {
       store = { ...store, ...update };
     }
     subscribers.forEach((callback) => callback(store));
   };

   const get = () => store;

   store = setup(set, get);

   const useCustomStore = () => {
     const [, forceRender] = useState(0);
     const stateRef = useRef(store);

     useEffect(() => {
       const callback = (newState) => {
         stateRef.current = newState;
         forceRender((prev) => prev + 1);
       };

       subscribers.add(callback);

       return () => {
         subscribers.delete(callback);
       };
     }, []);

     return store;
   };

   return useCustomStore;
 }

export default createStore;
